import { measure } from '@/components/Analytics/Analytics';
import AchievementIcon from '@/components/Icon/AchievementIcon';
import useAchievements from '@/hooks/useAchievements';
import useHaptics from '@/hooks/useHaptics';
import useUrlHistorySyncedOpenState from '@/hooks/useUrlHistorySyncedOpenState';
import { AnimatePresence } from 'framer-motion';
import AchievementsOverviewDialog from './AchievementsOverviewDialog';

const AchievementCounter = () => {
	const { withOnButtonPress } = useHaptics();

	const { achievements, score } = useAchievements();
	const [isOpened, setIsOpened] = useUrlHistorySyncedOpenState();

	if (score < 1) return null;

	return (
		<>
			<section
				aria-label="Appels"
				className="flex items-center justify-center rounded-full bg-slate-950 font-brand text-3xl leading-5">
				<button
					className="flex h-full items-center justify-center gap-1.5 rounded-full pe-2 ps-3 transition-all active:scale-90"
					aria-label={`Open appelsoverzicht (${score} appels)`}
					onClick={() => {
						setIsOpened(true);
						measure('achievements-open', 'navigation');
					}}
					{...withOnButtonPress}>
					{score} <span className="sr-only">appels</span>
					<AchievementIcon className="size-7 shrink-0 -translate-y-0.5 lg:size-7" />
				</button>
			</section>
			<AnimatePresence>
				{isOpened && (
					<AchievementsOverviewDialog
						onClose={() => {
							setIsOpened(false);
							measure('achievements-close', 'exit');
						}}
						achievements={achievements}
						score={score}
					/>
				)}
			</AnimatePresence>
		</>
	);
};

export default AchievementCounter;
